import { render, staticRenderFns } from "./TagCreation.vue?vue&type=template&id=07c3fb43&"
import script from "./TagCreation.vue?vue&type=script&lang=js&"
export * from "./TagCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports